<h2 mat-dialog-title>Reportar incidente</h2>
<mat-dialog-content>
  <p class="text-muted">
    {{ data.movimiento.EquipoTecnologico?.tipo }} - {{ data.movimiento.EquipoTecnologico?.marca }}
    {{ data.movimiento.EquipoTecnologico?.modelo }} (S/N: {{ data.movimiento.EquipoTecnologico?.numeroSerie }})
  </p>
  <div class="row">
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Motivo</mat-label>
        <mat-select [(ngModel)]="motivoIncidente">
          <mat-option *ngFor="let m of motivos" [value]="m.valor">{{ m.etiqueta }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Observación</mat-label>
        <textarea matInput [(ngModel)]="observacion" placeholder="Detalle de lo ocurrido (opcional)"></textarea>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="warn" type="button" [disabled]="guardando" (click)="guardar()">Reportar</button>
</mat-dialog-actions>
